module.exports = __webpack_public_path__ + "img/pleasure-icon-4.ae101ee3.svg";